import { ReactComponent as ArrowIcon } from '@apps/gated-2021/assets/arrow-left-one.svg';
import React from 'react';
import * as styled from './back-button.styled';

export const BackButton: React.FC<{ onClick: () => void }> = ({ onClick }) => {
    return (
        <styled.BackButton>
            <styled.Button variant={'link'} onClick={onClick}>
                <ArrowIcon />
                <span>BACK</span>
            </styled.Button>
        </styled.BackButton>
    );
};
